// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { WDSettingsUtils } from '../UtilsClasses/WDGeneralSettingsUtils';
import { DataCache } from '@shared/commons/DataCache';
import { AccountType } from '@shared/utils/Account/AccountType';
import { _AccountItemAll } from '../elements/Lookup/TerceraAccountLookup';
export class AccountLookUpSelectorProps {
}
export class AccountLookUpSelectorComponentView {
    constructor() {
        this.visible = false;
    }
}
export class AccountLookUpSelectorViewModel extends AbstractViewModel {
    get visible() {
        return this.componentView.visible;
    }
    set visible(value) {
        this.updateComponentView('visible', value);
    }
    get items() {
        return this.componentView.items;
    }
    set items(value) {
        this.updateComponentView('items', value);
    }
    get multiSelectDropDownItems() {
        return this.componentView.multiSelectDropDownItems;
    }
    set multiSelectDropDownItems(value) {
        this.updateComponentView('multiSelectDropDownItems', value);
    }
    get enabled() {
        return this.componentView.enabled;
    }
    set enabled(value) {
        this.updateComponentView('enabled', value);
    }
    constructor() {
        super(AccountLookUpSelectorComponentView);
        this.ItemAll = new _AccountItemAll();
    }
    initialize(props) {
        super.initialize(props);
        this.props = props;
        this.repopulate();
        this.updateEnabledState();
        this.visible = true;
    }
    update(props, prevProps) {
        super.update(props, prevProps);
        if (props.isMultiSelect !== prevProps.isMultiSelect) {
            this.repopulate();
        }
        this.props = props;
    }
    onSelectItem(item) {
        this.props.onSelectItem(item);
    }
    updateEnabledState() {
        const ignore = this.props.ignoreForceLinkingByAccount;
        const forceLinking = DataCache.EnableForceLinkingByAccount();
        this.enabled = ignore || !forceLinking;
    }
    repopulate() {
        const accounts = this.props.onlyOwnAccounts && DataCache.EnableForceLinkingByAccount()
            ? DataCache.getOwnedAccounts()
            : DataCache.getAccounts();
        if (DataCache.getNumberOfAccounts() === 1) {
            this.visible = false;
        }
        this.multiSelectDropDownItems = null;
        const excludeMultiAsset = this.props.excludeMultiAsset;
        if (this.props.isMultiSelect) {
            const multiSelectItems = {};
            multiSelectItems[this.ItemAll.AcctNumber] = this.ItemAll;
            for (const key in accounts) {
                const acc = accounts[key];
                if (excludeMultiAsset && acc.AccountType !== AccountType.MultiAsset)
                    continue;
                multiSelectItems[key] = acc;
            }
            this.setItems(multiSelectItems);
            const multiSelectDropDownItems = this.items.slice();
            // Removing ItemAll from multiSelectDropDownItems;
            const itemAllIdx = multiSelectDropDownItems.indexOf(this.ItemAll);
            if (itemAllIdx !== -1) {
                multiSelectDropDownItems.splice(itemAllIdx, 1);
            }
            this.multiSelectDropDownItems = multiSelectDropDownItems;
        }
        else {
            this.setItems(accounts);
            // Default account.
            const defAcc = WDSettingsUtils.selectedTradingAccount;
            let lastItem = this.props.selectedItem;
            if (!isNullOrUndefined(lastItem) && accounts[lastItem.BstrAccount] === undefined) {
                // #84959
                lastItem = null;
            }
            if (isNullOrUndefined(lastItem) && !isNullOrUndefined(defAcc)) {
                this.props.onSelectItem(defAcc);
            }
        }
    }
    setItems(newItems) {
        if (isNullOrUndefined(newItems)) {
            return;
        }
        const keys = Object.keys(newItems);
        const items = newItems;
        const len = keys.length;
        this.items = [];
        for (let j = 0; j < len; j++) {
            this.items.push(items[keys[j]]);
        }
    }
}
